import { customPinElement, customIconForMarker, ColorsList, customImageForMarker } from '../../features/core/utils'
import { Point } from '../../features/core/models/Point';
import { HistoricalDtcInfo } from './api/LastReportDtcs';
import { Cluster, ClusterStats, MarkerClusterer, Renderer } from '@googlemaps/markerclusterer';


interface MarkerProps {
    bgColor: string
}

export const getDefaultMarker = (point: Point) => {
    let marker = new google.maps.marker.AdvancedMarkerElement({
        position: {
            lng: point.lng,
            lat: point.lat
        }
    });
    
    return marker
}

export const getStopMarker = (point: Point, vehicleIndex: number) : google.maps.marker.AdvancedMarkerElement => {
    let icon = require('@/assets/stop' + vehicleIndex + '.png')
    let stopMarker = getDefaultMarker(point);
    stopMarker.content = customImageForMarker(icon),
    stopMarker.zIndex = 8;

    return stopMarker
}

export const getDtcMarker = (
    vehicleIndex: number, 
    dtc: HistoricalDtcInfo
) => {
    let dtcMarker = getDefaultMarker({
        lat: dtc['gps_latitude'],
        lng: dtc['gps_longitude']
    });
   


    let dtcImagePath = `f${vehicleIndex}`;
    let dtcStatus = dtc.status;
    //1 inactiva
    //2 activa
    if(dtcStatus === 2){
        dtcImagePath += '_activa'
    }
    let icon = require('@/assets/' + dtcImagePath + '.png');
    dtcMarker.content = customImageForMarker(icon)
    dtcMarker.zIndex = 9;

    return dtcMarker
}

export const clusterRenderer = ({
    imageUrl,
    aditionalLabelStyles = {},
}): Renderer => ({
    render: ({ count, position }) => {
        let pos = {
            lat: position.lat(),
            lng: position.lng()
        }

        let marker = getDefaultMarker(pos);
        let clusterIconAndLabel = document.createElement('div');
        clusterIconAndLabel.classList.add('clusterer-wrapper')
        let imgContent = customImageForMarker(imageUrl);


        let labelCount = document.createElement("span");
        for (const property in aditionalLabelStyles) {
            labelCount.style[property] = aditionalLabelStyles[property];
        }
        labelCount.classList.add('clusterer-wrapper--label');
        
        labelCount.innerHTML = count.toString();

        clusterIconAndLabel.appendChild(imgContent)
        clusterIconAndLabel.appendChild(labelCount)
        
        marker.zIndex = 9;
        marker.content = clusterIconAndLabel
        return marker
    }
});